import React from "react";
import { Icon } from "@nubeteck/components";
import { Spin } from "antd";
import {
  PaymentMethodCardStyled,
  PaymentMethodDescriptionStyled,
  PaymentMethodIconWrapperStyled,
  PaymentMethodsGridStyled,
  PaymentMethodTitleStyled,
} from "./payment-method-selector.styled";

export type PaymentMethod = "card" | "bac";

interface IPaymentMethodSelectorProps {
  content?: Record<string, string | undefined> | null;
  onSelect: (method: PaymentMethod) => void;
  loadingMethod?: PaymentMethod | null;
  disabled?: boolean;
}

const PaymentMethodSelector = ({
  content,
  onSelect,
  loadingMethod,
  disabled,
}: IPaymentMethodSelectorProps) => {
  const options = [
    {
      value: "card" as PaymentMethod,
      title: content?.method_card_title || "Tarjeta de crédito/débito",
      description: content?.method_card_description || "Visa, Mastercard y más",
      icon: "credit_card",
    },
  ];

  return (
    <PaymentMethodsGridStyled>
      {options.map((option) => {
        const isLoadingThis = loadingMethod === option.value;
        return (
          <PaymentMethodCardStyled
            key={option.value}
            type="button"
            disabled={disabled || !!loadingMethod}
            $disabled={disabled || !!loadingMethod}
            onClick={() => onSelect(option.value)}
          >
            <PaymentMethodIconWrapperStyled>
              {isLoadingThis ? <Spin size="small" /> : <Icon name={option.icon} />}
            </PaymentMethodIconWrapperStyled>
            <PaymentMethodTitleStyled>{option.title}</PaymentMethodTitleStyled>
            <PaymentMethodDescriptionStyled>
              {isLoadingThis
                ? content?.processing_label || "Procesando..."
                : option.description}
            </PaymentMethodDescriptionStyled>
          </PaymentMethodCardStyled>
        );
      })}
    </PaymentMethodsGridStyled>
  );
};

export default PaymentMethodSelector;
